<template>
  <div class="talk-memo-container">
    <div class="radio-group">
      <div class="radio-item" v-for="(channel, idx) in option.channel" :key="`opt-ch-${idx}`">
        <input type="radio" :id="`channel-${idx}`" :value="channel" v-model="value.channel">
        <label :for="`channel-${idx}`">{{ channel }}</label>
      </div>
    </div>
    <input type="text" class="manager input-border"
           v-model="value.manager" placeholder="고객서비스 담당자">

    <slot></slot>

    <div class="grid-row">
      <div class="grid-item">
        <input type="file" id="memo-file-uploader"
               @change="onFileChange"
               accept="image/gif, image/jpeg, image/png, .docx, .pptx, .xlsx, .hwp, .pdf, .zip">
        <label for="memo-file-uploader">
          <div class="button is-gray" style="width: 100%">파일첨부</div>
        </label>
        <div class="size-12" style="margin:4px 0" v-if="value.file && value.file.name">{{ value.file.name }}</div>
      </div>
      <div class="grid-item">
        <input type="text" class="grid-item input-border" v-model="value.link" placeholder="참고 링크 주소">
      </div>
    </div>

    <div class="grid-row">
      <div class="grid-item">
        <select class="input-border" v-model="value.cat1" @change="onChange">
          <option :value="0">구분</option>
          <option v-for="(cat, idx) in option.cats1" :key="`opt-cat1-${idx}`"
                  :value="cat.id">{{ cat.name }}</option>
        </select>
      </div>
      <div class="grid-item">
        <select class="input-border" v-model="value.cat2">
          <option :value="0" disabled>구분2</option>
          <option v-for="(cat, idx) in option.cats2" :key="`opt-cat2-${idx}`"
                  :value="cat.id">{{ cat.name }}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TalkMemo',
    created() {
      this.init();
    },
    data() {
      return {
        value: {
          cat1: 0,
          cat2: 0,
          manager: '',
          channel: '메모',
          link: '',
          file: undefined,
        },
        option: {
          cats1: [],
          cats2: [],
          channel: ['메모', '전화', '이메일', '홈페이지', '오프라인 미팅', '이메일&전화', '시트', '카카오톡']
        },
      }
    },
    methods: {
      init() {
        this.$axios.get(this.getUrl('memo_category')).then(res => {
          this.option.cats1 = res.data;
        });
      },
      onFileChange(e) {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onload = f => {
          let ext = '';
          if(file.name.indexOf('.')>-1) {
            ext = file.name.split('.').slice(-1)[0];
          }
          this.value.file = {
            name: file.name,
            file: f.target.result,
            size: file.size,
            extension: ext
          }
        }
        reader.readAsDataURL(file);
      },
      onChange() {
        let cats = this.option.cats1.filter(i=>i.id === this.value.cat1);
        if(cats.length>0) {
          this.option.cats2 = cats[0].child;
          this.value.cat2 = this.option.cats2[0].id;
        } else {
          this.option.cats2 = [];
          this.value.cat2 = 0;
        }
      },
      getValue() {
        let value = this.cloneItem(this.value);
        let cat1 = this.option.cats1.filter(i=>i.id === value.cat1);
        if(cat1.length>0) {
          cat1 = cat1[0];
          value.cat1 = cat1.name;
          value.cat1_id = cat1.id;
          value.cat2 = cat1.child.filter(i=>i.id === value.cat2)[0].name;
        }
        return value;
      }
    }
  }
</script>

<style lang="stylus" scoped>

  .grid-row
    display grid
    gap 8px
    margin-bottom 8px
    grid-template-columns 1fr 2fr

  input[type=file]
    position absolute
    width 0
    height 0
    border 0 !important

  .radio-group
    display flex
    flex-wrap wrap
    align-items center
    gap 12px
    margin-bottom 12px
  .radio-item
    display flex
    align-items center
    gap 4px

  .manager
    width 130px
    margin-bottom 12px
</style>
